import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService';
import { Link } from 'react-router-dom';
import {
    Row, Col, Card, CardImg, CardText, CardBody,
    CardTitle, Button, Spinner
} from 'reactstrap';

import {
    CONFIG_BASE_API_URL,
} from '../constans';
export class TrainingSelectionPage extends Component {
    static displayName = TrainingSelectionPage.name;

    constructor(props) {
        super(props);
        this.state = { availableTrainingData: null, loading: true };
    }

    componentDidMount() {
        this.populateTrainingData();
    }

    renderAvailableTrainings() {
        return (
            <div>
                <Row>
                    <Col className="py-3">
                        <h2>Mijn modules</h2>
                        <hr />
                    </Col>
                </Row>
                <Row xs="1" sm="2" xl="4">
                    {this.state.availableTrainingData.ownTrainings.map((training) => {
                        return (
                            <Col key={training.id}>

                                <div className="d-block d-sm-none">
                                    <Card className="mb-4 mx-5 shadow-sm">
                                        <CardImg top width="100%" src={training.coverPhotoUrl} alt="" />
                                        <CardBody>
                                            <CardTitle tag="h4">{training.name}</CardTitle>
                                            <CardText>{training.shortDescription}</CardText>
                                            <hr />
                                            <div className="text-center">
                                                <a href={"/training/" + training.id}>Bekijk training</a>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>

                                <div className="d-none d-sm-block">
                                    <Card className="mb-4 shadow-sm">
                                        <CardImg top width="100%" src={training.coverPhotoUrl} alt="" />
                                        <CardBody>
                                            <CardTitle tag="h4">{training.name}</CardTitle>
                                            <CardText>{training.shortDescription}</CardText>
                                            <hr />

                                            <div className="text-center">
                                                <a href={"/training/" + training.id}>Bekijk training</a>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>

                            </Col>
                        )
                    })}
                </Row >
            </div>
        );
    }


    render() {

        if (this.state.loading == true) {
            return (
                <React.Fragment>
                    <Row>
                        <div className="col-sm center-loading-spinner">
                            <Spinner className="spinner-settings" type="border" color="primary" />
                            <div className="pt-4">Trainingen laden...</div>
                        </div>
                    </Row>
                </React.Fragment>);


        }


        let owntrainings;
        let showOwnTrainings = false;
        let errorMessage = false;


        if (this.state.availableTrainingData.isCompanyAdmin) {
            if (this.state.availableTrainingData.ownTrainings != null) {
                showOwnTrainings = true;
            }
            else {
                if (this.state.availableTrainingData.accountHasStudent) {
                    errorMessage = (<div>Er zijn geen trainingen toegekend aan uw account.<br /><br />Omdat u trainer rechten heeft, kan u deze zelf toevoegen.<br />Dit doet u via <a href="https://portal.logisticworkx.com/training/students">https://portal.logisticworkx.com/training/students</a> </div>);
                }
                else {
                    errorMessage = (<div>Uw account staat geregistreerd als trainer, maar niet als cursist.<br /><br />Wilt u zelf ook trainen? Bezoek dan <a href="https://portal.logisticworkx.com/training/students">https://portal.logisticworkx.com/training/students</a> en maak een cursist aan voor uw e-mailadres.<br/>Hierna kan u zelf trainingen toevoegen aan uw account.</div>);
                }
            }
        }
        else {
            if (this.state.availableTrainingData.ownTrainings != null) {
                showOwnTrainings = true;
            }
            else {
                errorMessage = (<div>Er zijn geen trainingen toegekend aan uw account.<br/>Neem contact op met uw trainer.</div>);
            }
        }


        if (showOwnTrainings) {
            owntrainings = (this.renderAvailableTrainings());
            return (<React.Fragment>{owntrainings}</React.Fragment>);
        }


        return (
            <React.Fragment>
                <Row>
                    <Col className="text-center pt-5">
                        <h3 className="pb-2"><b>Geen trainingen gevonden!</b></h3>
                        <h5>{errorMessage}</h5>
                    </Col>
                </Row >
            </React.Fragment>
        );
    }


    // get training data
    async populateTrainingData() {
        const token = await authService.getAccessToken();

        const response = await fetch(CONFIG_BASE_API_URL + '/training/available', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (!data.isSuccess) {
        }
        else {
            this.setState({ availableTrainingData: data.responseData, loading: false });
        }
    }
}

